import React, { useContext } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { PlanPrint } from "./PlanPrint";
import { MyContext } from "@/store/myContext";

export default () => {
    const { state } = useContext(MyContext);

    return (
        <>
            {state.activeMenu === "purchasePlan" && <>
                <PageHeader />
                <DataBox />
                <PlanPrint />
            </>}
        </>
    )
}